export enum Language {
	EN = "en",
	FR = "fr",
	DE = "de",
	ES = "es",
	RU = "ru",
	IT = "it",
	HY = "hy",
	HI = "hi",
	BN = "bn",
}
